<template>
  <div>
    <vm-table
        ref="vmTable"
        height="62vh"
        :filter.sync="filter"
        module="basic"
        url="soas"
        @select="selectAll"
        @select-all="selectAll">
      <!-- Search Begin -->
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="对账单号">
            <el-input v-model.trim="filter.billNo" placeholder="请输入对账单号" clearable/>
          </vm-search>
          <vm-search label="送货单号">
            <el-input v-model.trim="filter.purchaseReceiveNo" placeholder="请输入送货单号" clearable/>
          </vm-search>
          <vm-search label="采购单号">
            <el-input v-model.trim="filter.sapPurchaseOrderNo" placeholder="请输入采购单号" clearable/>
          </vm-search>
          <vm-search label="供应商名称">
            <el-input v-model.trim="filter.supplierName" placeholder="请输入供应商名称" clearable/>
          </vm-search>
          <vm-search label="采购组">
            <el-input v-model.trim="filter.buyUserName" placeholder="请输入采购组" clearable/>
          </vm-search>
          <vm-search label="发票号码">
            <el-input v-model.trim="filter.invoiceNo" placeholder="请输入发票号码" clearable/>
          </vm-search>
          <vm-search label="MES状态">
            <el-select v-model="filter.statusName">
              <el-option label="全部" value=""/>
              <el-option label="草稿" value="草稿"/>
              <el-option label="采购经理审批" value="采购经理审批"/>
              <el-option label="采购确认开票申请" value="采购确认开票申请"/>
              <el-option label="供应商开票" value="供应商开票"/>
              <el-option label="采购确认发票信息" value="采购确认发票信息"/>
              <el-option label="财务确认发票信息" value="财务确认发票信息"/>
              <el-option label="已完成" value="已完成"/>
            </el-select>
          </vm-search>
          <vm-search label="云报账状态">
            <el-select v-model="filter.cloudSoaStatus" placeholder="请选择云报账状态">
              <el-option label="已结束" value="9"/>
              <el-option label="未知" value="-1"/>
              <el-option label="单据草稿" value="1"/>
              <el-option label="待清欠处理" value="20"/>
              <el-option label="待审批流发起" value="24"/>
              <el-option label="审批流发起失败" value="25"/>
              <el-option label="业务审批中" value="30"/>
              <el-option label="预算使用中" value="31"/>
              <el-option label="待影像处理" value="35"/>
              <el-option label="影像处理中" value="40"/>
              <el-option label="待单据推送共享" value="45"/>
              <el-option label="共享审批中" value="50"/>
              <el-option label="共享已审批" value="60"/>
              <el-option label="已撤回" value="70"/>
              <el-option label="业务审批退回" value="80"/>
              <el-option label="共享审批退回" value="85"/>
              <el-option label="影像退回" value="90"/>
              <el-option label="待发票后补" value="91"/>
              <el-option label="退回至业务系统" value="94"/>
              <el-option label="待支付" value="0"/>
              <el-option label="支付退回" value="2"/>
              <el-option label="支付退汇" value="3"/>
              <el-option label="支付中" value="4"/>
              <el-option label="支付退回" value="6"/>
              <el-option label="已作废" value="8"/>
              <el-option label="部分支付" value="110"/>
              <el-option label="支付挂起" value="111"/>
            </el-select>
          </vm-search>
          <vm-search label="审批日期">
            <el-date-picker
                v-model="submitTime"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="submitTimeChange"/>
          </vm-search>
        </div>
      </template>
      <!-- Search End -->
      <div slot="toolbar">
        <el-button type="primary" :loading="exportLoading" @click="exportExcel()">导出</el-button>
        <el-button
            v-if="cloudStatusAuth"
            :disabled="selection.length !==1"
            type="success"
            :loading="updateStatusLoading"
            @click="updateCloudStatus(selection)">
          云报账同步
        </el-button>
        <el-button
            v-if="cloudEdith"
            :disabled="selection.length !==1"
            type="primary"
            @click="cloudEdit(selection)">
          编辑
        </el-button>
        <el-button
            v-if="submitCloud"
            :loading="submitToCloudLoading"
            :disabled="selection.length !==1"
            type="success"
            @click="submitToCloud(selection)">
          提交云报账
        </el-button>
      </div>
      <el-table-column type="selection" align="center" width="40"/>
      <el-table-column prop="billNo" align="center" width="100" label="对账单号">
        <template slot-scope="scope">
          <span style="cursor: pointer; color:#2d8cf0" @click="goToPreview(scope.row)">{{scope.row.billNo}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="billType" width="100" label="对账类型">
        <template v-slot="scope">
          <span v-if="scope.row.billType === 10">整单对账</span>
          <span v-if="scope.row.billType === 20">拆单对账</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="supplierName"
          align="center"
          label="供应商名称"
          min-width="150"
          show-overflow-tooltip/>
      <el-table-column
          prop="buyUserName"
          align="center"
          label="采购组"
          min-width="110"
          show-overflow-tooltip/>
      <el-table-column
          prop="creatorName"
          align="center"
          label="创建人"
          min-width="100"
          show-overflow-tooltip/>
      <el-table-column prop="submitTime" align="center" width="140" label="提交时间"/>
      <el-table-column prop="statusName" align="center" width="140" label="MES状态"/>
      <el-table-column prop="cloudSoaStatusName" align="center" width="140" label="云报账状态"/>
      <el-table-column prop="note" label="备注" width="160" show-overflow-tooltip/>
      <el-table-column prop="createTime" align="center" width="140" label="创建时间"/>
      <el-table-column prop="purchase2ndApproveTime" align="center" width="140" label="采购确认发票"/>
      <el-table-column prop="submitCloudTime" align="center" width="140" label="财务审批时间"/>
      <el-table-column
          v-if="editAuth"
          label="操作"
          align="center"
          fixed="right"
          width="280px">
        <template slot-scope="scope">
          <el-button type="primary" :disabled="scope.row.status !== 0 || submitLoading" @click="$refs.reconcileOrderEdit.open(1, scope.row)">编辑</el-button>
          <el-button type="primary" :loading="submitLoading" :disabled="scope.row.status !== 0" @click="submitHandle(scope.row)">提交</el-button>
          <el-button v-if="scope.row.status === 0 || (scope.row.cloudSoaStatus !== '9' && scope.row.cloudSoaStatus !== '90' && scope.row.cloudSoaStatus !== null)" type="danger" :loading="deleteLoading" @click="deleteHandle(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <reconcile-order-edit ref="reconcileOrderEdit" @save-success="getList"/>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import ReconcileOrderEdit from "./ReconcileOrderEdit.vue";
  import LoginUtil from "@/util/loginUtil";

  export default {
    name:"ReconcileOrderList",
    components: { VmTable, VmSearch, ReconcileOrderEdit },
    data() {
      return {
        submitLoading:false,
        updateStatusLoading:false,
        deleteLoading:false,
        editAuth: this.$auth(959),
        cloudStatusAuth: this.$auth(662),
        cloudEdith:this.$auth(663),
        submitCloud:this.$auth(664),
        submitToCloudLoading:false,
        userType: LoginUtil.getUserType(),
        name: LoginUtil.getName(),
        exportLoading:false,
        filter: {
          billNo: "",
          supplierName: "",
          status: "",
          statusName:"",
          purchaseReceiveNo:"",
          sapPurchaseOrderNo:"",
          buyUserName:"",
          cloudSoaStatus:"",
          submitDateBegin:"",
          submitDateEnd:"",
        },
        selection:[],
        submitTime:"",
      };
    },

    mounted() {
      if (this.userType === 1) {
        this.filter.buyUserName = this.name;
      }
      this.getList(1);
    },

    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      selectAll(selection) {
        this.selection = selection;
      },

      submitTimeChange(date) {
        if (date !== null) {
          this.filter.submitDateBegin = date[0];
          this.filter.submitDateEnd = date[1];
        } else {
          this.filter.submitDateBegin = "";
          this.filter.submitDateEnd = "";
        }
      },

      // 删除未提交的对账单
      deleteHandle(row) {
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http.delete("basic", "soas", row.pkId).then((res) => {
            if (res.success) {
              this.$message.success("删除成功");
              this.getList(1);
            }
          });
        });
      },

      goToPreview(row) {
        this.$router.push({
          path: "/ReconcileOrderDetail",
          query: {
            billType: 27,
            billId: row.pkId,
            sequId: -1,
            $tabName: "对账管理详情" + row.billNo,
          },
        });
      },  

      // 提交
      submitHandle(row) {
        this.$confirm("确定提交吗?", "提示", { type: "warning" }).then(() => {
          this.submitLoading = true;
          this.$http.post("basic", `soas/submit/${row.pkId}`).then((res) => {
            if (res.success) {
              this.submitLoading = false;
              this.$message.success("提交成功");
              this.getList(1);
            }
          }).catch(()=>{
            this.submitLoading = false;
          });
        });
      },

      exportExcel() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic", "soas/exportList", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },

      updateCloudStatus() {
        let row=this.selection[0];
        this.updateStatusLoading=true;
        this.$http.get("basic", `soas/queryCloudStatus/${row.pkId}`)
          .then((res) => {
            this.$message.success("更新成功");
            this.getList(1);
          }).finally(()=>{
            this.updateStatusLoading=false;
          });
      },

      cloudEdit() {
        let row=this.selection[0];
        this.$refs.reconcileOrderEdit.open(1, row);
      },

      submitToCloud() {
        this.submitToCloudLoading=true;
        let row=this.selection[0];
        this.$http.get("basic",`soas/submitToCloud/${row.pkId}`)
          .then((resp)=>{
            this.$message.success("更新成功");
            this.getList(1);
          }).finally(()=>{
            this.submitToCloudLoading=false;
          });
      },
    },
  };
</script>
